module.exports = "https://cdn.nebula.starbreeze.com/legal/static/media/Nebula.5d1649ed.svg";